import {
  ICustomer,
  ICustomerGridItem,
  ICustomerLookupValue, ICustomerSnapshot,
  IPrimitiveResponse
} from '../../model';
import { ICustomerUpsert } from '../../model/api/customers/customer-upsert';
import {State as DataState} from '@progress/kendo-data-query';
import { getApi } from './api';
import {buildSearchQueryString} from "../../utils/kendo-query-builder";

interface KendoDataResult {
  data: Array<ICustomerGridItem>;
  total: number;
}

const URL = '/customer';

const get = async (id: string | undefined): Promise<ICustomer> => {
  const api = await getApi();
  return api
    .get<ICustomer>(`${URL}/${id}`)
    .then((response) => response.data)
    .then((res) => {
      res.createdAt = new Date(res.createdAt);
      return res;
    });
};

const remove = async (ids: number[]): Promise<void> => {
  const idsParams = ids.map((x) => `id=${x}`).join('&');
  const api = await getApi();
  return api
    .delete<void>(`${URL}?${idsParams}`)
    .then((response) => response.data);
};

const getLookupValues = async (): Promise<ICustomerLookupValue[]> => {
  const api = await getApi();
  return api
    .get<ICustomerLookupValue[]>(`${URL}/lookup-values`)
    .then((response) => response.data);
};

const create = async (customer: ICustomerUpsert) => {
  const api = await getApi();
  return api
    .post<{ id: number }>(`${URL}`, customer)
    .then((response) => response.data.id);
};

const update = async (id: number, customer: ICustomerUpsert) => {
  const api = await getApi();
  return api
    .put<void>(`${URL}/${id}`, customer)
    .then((response) => response.data);
};

const updateSnapshot = async (id: number, customerSnapshot: ICustomerSnapshot) => {
  const api = await getApi();
  return api
      .put<void>(`${URL}/${id}/snapshot`, customerSnapshot)
      .then((response) => response.data);
};

const deactivate = async (id: number) => {
  const api = await getApi();
  return api
    .put<void>(`${URL}/${id}/deactivate`)
    .then((response) => response.data);
};

const anyConnectedServiceCollision = async (customerId: number, connectedServiceId: number) => {
  const api = await getApi();
  return api
    .get<IPrimitiveResponse<boolean>>(`${URL}/${customerId}/service-collision/${connectedServiceId}`)
    .then((response) => response.data);
};

const anyModuleCollision = async (customerId: number, moduleId: number) => {
  const api = await getApi();
  return api
    .get<IPrimitiveResponse<boolean>>(`${URL}/${customerId}/module-collision/${moduleId}`)
    .then((response) => response.data);
};

const getListForGrid = async (
    dataState: DataState,
    query: string | undefined | null
): Promise<{ data: ICustomerGridItem[], total: number }> => {
  const queryString = buildSearchQueryString(dataState, query);
  const api = await getApi();

  return api
      .get<KendoDataResult>(`${URL}/kendo-grid-list?${queryString}`)
      .then((response) => response.data)
      .then((res) => {
        return {
          data: res.data,
          total: res.total,
        };
      });
};

const updateSnapshotTicket = async (customerId: number, ticketId: string) => {
    const api = await getApi();
    return api
        .patch<void>(`${URL}/snapshot-ticket`, { CustomerId: customerId, TicketId: ticketId })
        .then((response) => response.data);
}


export const customersService = {
  get,
  remove,
  getLookupValues,
  create,
  update,
  deactivate,
  anyConnectedServiceCollision,
  anyModuleCollision,
  getListForGrid,
  updateSnapshotTicket,
  updateSnapshot,
};
